





























































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import ImportFilesInjectorMixin from "@/mixins/importFilesInjectorMixin";

// Types
import { IFile } from "@/models/files";
import { IImportSourceError } from "@/models/imports";

@Component({
  components: {
    "import-files-list-item": () =>
      import("@/components/app/admin/imports/importFileListItem.vue")
  }
})
export default class ImportFilesListing extends Mixins(
  ImportFilesInjectorMixin
) {
  // Props

  @Prop({ default: () => null })
  public selectedFileIds!: IFile["id"];

  @Prop({ default: () => [] })
  public sourceFilesErrors!: IImportSourceError[];

  @Prop({ default: true })
  public showStatus!: boolean[];

  // Methods

  public hasActiveError(fileId) {
    return this.$_.some(
      this.sourceFilesErrors,
      sourceFilesError =>
        sourceFilesError.id === fileId && sourceFilesError.isActive
    );
  }

  // Computed

  public get skeletonSize() {
    const { data } = this.$importFilesData.table;
    if (data.length) return data.length;

    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return (
      !this.$importFilesData.isLoading &&
      !this.$importFilesData.table.data.length
    );
  }

  public get showSkeletons() {
    return this.$importFilesData.isLoading || !this.$importFilesData.total;
  }
}
